module.exports = __webpack_public_path__ + "4a27a4b9266d954a308e4a64dc4664ad.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/pot-s.png
// module id = 2322
// module chunks = 0